import { autorun, makeAutoObservable } from 'mobx';
import { gameGlobalStates } from '../powerOfGodsCore/constants/globalConstants';
import { powerOfGodsStore } from './powerOfGodsStore';

export class GameStore {
  isForceStop = false;

  isResponseReady = false;

  isSpinButtonHold = false;

  spinResult = null;

  bonusSpinResult = null;

  isReelRotating = false;

  HasRingWinAnimation = false;

  cashOutPopUpType = null;

  skipWin = false;

  winStarted = false;

  gameGlobalState = gameGlobalStates.none;

  winEnded = false;

  hasCashOut = false;

  isInBonusScene = false;

  mustInitBonusSceneOnInitialState = false;

  mustInitBonusScene = false;

  bonusSceneFinished = false;

  bonusResulSymbolFromInitialState = 0;

  constructor() {
    makeAutoObservable(this);
    autorun(() => {
      const currentState = this.gameGlobalState;

      if (
        currentState === gameGlobalStates.show ||
        (currentState === gameGlobalStates.waiting && this.isReelRotating && !this.isForceStop) ||
        currentState === gameGlobalStates.bonus.bonusInitComplete ||
        currentState === gameGlobalStates.none
      ) {
        powerOfGodsStore.setIsAllowBet(true);
      } else {
        powerOfGodsStore.setIsAllowBet(false);
      }
    });
  }

  setIsForceStop(v) {
    this.isForceStop = v;
  }

  setWinStarted(v) {
    this.winStarted = v;
  }

  setIsSpinButtonHold(v) {
    this.isSpinButtonHold = v;
  }

  showLineAutoCashOutPopUp(type) {
    this.cashOutPopUpType = type;
  }

  setBonusSceneFinished(bool) {
    this.bonusSceneFinished = bool;
  }

  hideLineAutoCashOutPopUp() {
    this.cashOutPopUpType = null;
  }

  setIsInBonusScene(v) {
    this.isInBonusScene = v;
  }

  setHasCashOut(v) {
    this.hasCashOut = v;
  }

  setIsResponseReady(v) {
    this.isResponseReady = v;
  }

  setMustInitBonusSceneOnInitialState(v, resultSymbol) {
    this.mustInitBonusSceneOnInitialState = v;
    this.bonusResulSymbolFromInitialState = resultSymbol;
  }

  setMustInitBonusScene(bool) {
    this.mustInitBonusScene = bool;
  }

  setSpinResult(v) {
    this.spinResult = v;
    this.setIsResponseReady(true);
  }

  setBonusSpinResult(v) {
    this.bonusSpinResult = v;
    this.setIsResponseReady(true);
  }

  setIsReelRotating(v) {
    this.isReelRotating = v;
  }

  setHasRingWinAnimation(v) {
    this.HasRingWinAnimation = v;
  }

  setSkipWin(v) {
    this.skipWin = v;
  }

  setGameGlobalState(v) {
    this.gameGlobalState = v;
  }

  setWinEnded(v) {
    this.winEnded = v;
  }

  getLinesAndSymbolFromSpinResult() {
    if (!this.spinResult?.result) {
      throw new Error('Invalid spinResult structure');
    }
    const { result } = this.spinResult;
    return {
      small: result.line1,
      middle: result.line2,
      big: result.line3,
      resultSymbol: result.resultSymbol,
      winInfo: result.winInfo,
      bonusInfo: result.bonusInfo,
    };
  }

  resetAfterReelStopComplete() {
    this.setSkipWin(false);
    this.setIsForceStop(false);
    this.setIsResponseReady(false);
    this.setIsReelRotating(false);
  }

  resetAfterBonusReelStopComplete() {
    this.setIsForceStop(false);
    this.setIsResponseReady(false);
    this.setBonusSpinResult(null);
    this.setIsReelRotating(false);
    this.setSkipWin(false);
  }

  resetForStartSpin() {
    this.setIsForceStop(false);
    this.setIsResponseReady(false);
    this.setIsReelRotating(false);
    this.setWinEnded(false);
    this.setWinStarted(false);
  }

  resetAll() {
    this.setHasRingWinAnimation(false);
    this.setIsForceStop(false);
    this.setIsResponseReady(false);
    this.setIsReelRotating(false);
    this.setWinEnded(false);
    this.setBonusSpinResult(null);
    this.setSpinResult(null);
    this.setGameGlobalState(gameGlobalStates.none);
    this.setSkipWin(false);
    this.setIsInBonusScene(false);
  }
}
